"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ErrorBox;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _useDeviceInfo = _interopRequireDefault(require("../../utils/useDeviceInfo"));
require("./styles.scss");
function ErrorBox(props) {
  const {
    text,
    onClick,
    buttonText,
    title,
    className,
    sx
  } = props;
  const {
    isMobile
  } = (0, _useDeviceInfo.default)();
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "error-box ".concat(className, " ").concat(isMobile ? 'mobile' : ''),
    sx: sx
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "error-box--container"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "error",
    className: "error-icon",
    size: "large"
  }), /*#__PURE__*/_react.default.createElement("div", null, title && /*#__PURE__*/_react.default.createElement("h1", {
    className: "error-title"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "error-text"
  }, text))), buttonText && onClick && /*#__PURE__*/_react.default.createElement("div", {
    className: "button-container"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    label: buttonText,
    priority: "secondary",
    type: "passive",
    onClick: onClick
  })));
}